export { default as NNumberAnimation, numberAnimationProps } from './src/NumberAnimation';
